import React from 'react';
import RoutesApp from './routesApp';

function App() {
  return (
    <div>
      <RoutesApp />
    </div>
  );
}

export default App;
